export default __webpack_public_path__ + "static/media/dick-dick_logo_grau.fe7165ee.svg";